/* eslint-disable */
/**
 * Bootstrap the `pendo` namespace for deferred execution of common methods until the Agent is fully loaded
 * from the CDN. The deferred methods are: a) initialize b) identify c) updateOptions d) pageLoad.
 */
module.exports = (apiKey) => {
  (function (p, e, n, d, o) {
    var v, w, x, y, z;
    o = p[d] = p[d] || {};
    o._q = [];
    v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
    for (w = 0, x = v.length; w < x; ++w) {
      (function (m) {
        o[m] = o[m] || function () {
          o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
        };
      })(v[w]);
    }
    y = e.createElement(n);
    y.async = !0;
    y.src = 'https://content.engagement.boomi.com/agent/static/' + apiKey + '/pendo.js';
    z = e.getElementsByTagName(n)[0];
    z.parentNode.insertBefore(y, z);
  })(window, document, 'script', 'pendo');
};
